import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import provinceReducer from './slices/provinceSlice'
import provinceRulesProvider from './slices/rulesSlice';
import userReducer from './slices/userSlice';
import propertyReducer from './slices/propertySlice';
import leaseReducer from './slices/LeaseSlice';
import paymentReducer from './slices/paymentSlice';
import noticeReducer from './slices/noticeSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  province: provinceReducer,
  province_rule:provinceRulesProvider,
  user: userReducer,
  property: propertyReducer,
  lease: leaseReducer,
  payments: paymentReducer,
  notices: noticeReducer,
});

export default rootReducer;
